export function highlightSearchTerms() {
    // Getting the value of the 'search' parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('s');
    // Make sure we have a search term
    if (searchTerm) {
        // Select the items to search for text
        // You can customize the selector to suit your needs
        const contentElements = document.querySelectorAll('.wp-block-post-excerpt__excerpt');

        // Create a case-sensitive regular expression
        const searchRegex = new RegExp(`(${searchTerm})`, 'gi');

        contentElements.forEach(element => {
            // Include all span tag matches with 'highlight' class
            element.innerHTML = element.innerHTML.replace(searchRegex, `<strong class="highlighted">$1</strong>`);
        });
    }
}